import React from 'react';

function Line(props: any) {
    return <div className="h-0.5 bg-ellipse-bg"></div>;
}

export default Line;
